export class TypeContact {
  public id: number;
  public typeContact?: string;
}
